import { useMe } from '../../hooks/queries'

/**
 * Whether this account sees the new navigation (#174, `users.new_ui`, set
 * only by the administration). In a module of its own so the trip list can
 * ask without importing the bars, which import the list themselves.
 */
export function useNewNavigation(): boolean {
  return useMe().data?.new_ui === true
}
